import { render, staticRenderFns } from "./AdminCampaigns.vue?vue&type=template&id=4324b9ec&"
import script from "./AdminCampaigns.vue?vue&type=script&lang=ts&"
export * from "./AdminCampaigns.vue?vue&type=script&lang=ts&"
import style0 from "./AdminCampaigns.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports